<template>
  <table
    class="base-table"
    cellspacing="0"
    :class="classes"
  >
    <slot />
  </table>
</template>

<script>
export default {
  name:  'BaseTable',
  props: {
    stripedEven: {
      type:    Boolean,
      default: false,
    },
    stripedOdd: {
      type:    Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'striped-even': this.stripedEven,
        'striped-odd':  this.stripedOdd,
      };
    },
  },
};
</script>

<style scoped>
  table {
    border: 2px solid #f0eeee;
  }

  .base-table {
    width: 100%;
  }

  .base-table td, .base-table th {
    padding: 6px 12px;
  }

  .base-table.striped-even tr:nth-child(even) {
    background-color: #f0eeee;
  }

  .base-table.striped-odd tr:nth-child(odd) {
    background-color: #f0eeee;
  }
</style>
